<template>
  <div>
    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/productCenter/backgroundImg.jpg')
            : require('@/assets/images/productCenter/en_backgroundImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="18">
          <el-card
            v-for="(item, index) in cardData"
            :key="index"
            class="contentBox"
          >
            <div class="card">
              <div>
                <img class="card-img" :src="item.pic" />
              </div>
              <div class="card-right">
                <span class="title">{{ item.title }}</span>
                <div v-html="xss(item.content)"></div>
                <!-- <div>
                  <span class="name">课程名称：</span>
                  <span class="content">{{ item.title }}</span>
                </div>
                <div>
                  <span class="name">飞机型别：</span>
                  <span class="content">A1616</span>
                </div>
                <div>
                  <span class="name">时间：</span>
                  <span class="content-indent"
                    >机型地面课 100 小时 , 一般科目 20 小时， 全动。</span
                  >
                </div>
                <div style="display:flex;align-items: center;">
                  <div class="name">目标：</div>
                  <div class="content-indent" v-html="item.content"></div>
                </div> -->
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/acticle/acticle";
export default {
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      cardData: [],
    };
  },
  created() {
    this.load(this.$route.params.id);
  },
  watch: {
    $route: "setRouteName",
  },
  methods: {
    setRouteName() {
      this.load(this.$route.params.id);
    },
    load(id) {
      getIndex({ id })
        .then((res) => {
          if (res.code === 0) {
            this.cardData = res.data.data;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.backImg {
  width: 100%;
  /* height: 300px; */
}
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.container {
  padding: 20px;
}
.contentBox {
  margin-bottom: 20px;
  border-radius: 20px;
}
.card {
  display: flex;
}
.card-img {
  width: 400px;
  /* width: 100%; */
  height: auto;
}
.card-right {
  margin-left: 20px;
  margin-top: 5px;
}
.title {
  color: #015a9c;
  font-size: 15px;
  padding: 5px;
  background-color: rgba(237, 246, 255, 1);
}
.card-right > div {
  margin-top: 10px;
}
.name {
  color: #97989d;
  font-size: 13px;
}
.content {
  font-weight: 800;
  font-size: 14px;
}
.content-indent {
  font-weight: 800;
  font-size: 14px;
  margin-left: 26px;
}
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .card {
    display: block;
  }
  .card-img {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  .card-right {
    margin-left: 0;
  }
}
</style>